import axios from 'axios'
import qs from 'qs'
import { Loading, Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

// let loadingInstance

const service = axios.create({
  baseURL: '/journal'
  // timeout: 2000 // 请求超时时间
})

service.interceptors.request.use(config => {
  NProgress.start()
  if (config.method === 'FILEPOST' || config.method === 'PROFILEPOST') {
    config.headers['Content-Type'] = 'multipart/form-data'
  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    if (response.data.code == 0) {

      // loadingInstance.close()
    } else if (response.data.code == -15) {
      Message.warning('登录信息已失效，请重新登录')
      window.location.href = BSsetting.loginExpiredUrl
      // loadingInstance.close()
    } else {
      Message.error(response.data.message)
    }

    NProgress.done()
    return response
  },
  error => {
    console.log('err' + error)
    NProgress.done()
    Message.error('遇到点小问题啦,不要紧张.请联系管理员解决哦!!' + error)
  }
)

export default (url = '', data = {}, method = '', param = {}, config = {}) => {
  // GET请求约定格式 数组格式a[0]=1&a[1]=2
  if (method == 'GET') {
    return new Promise((resolve, reject) => {
      service.get(url, {
        params: data,
        paramsSerializer: params => {
          return qs.stringify(params)
        },
        config
      })
        .then((res) => {
          if (res) {
            resolve(res.data)
          } else {
            resolve(res)
          }
        }).catch((err) => {
          reject(err)
        })
    })
  }

  // GET请求约定格式 数组格式a=1&a=2
  if (method == 'ARRGET') {
    return new Promise((resolve, reject) => {
      service.get(url, {
        params: data,
        paramsSerializer: params => {
          return qs.stringify(params, {
            arrayFormat: 'repeat'
          })
        }
      })
        .then((res) => {
          if (res) {
            resolve(res.data)
          } else {
            resolve(res)
          }
        }).catch((err) => {
          reject(err)
        })
    })
  }

  // GET请求格式，对象格式data.id=1
  if (method == 'OBJGET') {
    return new Promise((resolve, reject) => {
      service.get(url, {
        params: data,
        paramsSerializer: params => {
          return qs.stringify(params, {
            arrayFormat: 'indices', allowDots: true
          })
        }
      })
        .then((res) => {
          if (res) {
            resolve(res.data)
          } else {
            resolve(res)
          }
        }).catch((err) => {
          reject(err)
        })
    })
  }

  // POST请求约定格式 对象格式data.id=1
  if (method == 'POST') {
    return new Promise((resolve, reject) => {
      service.post(url, qs.stringify(data, { arrayFormat: 'indices', allowDots: true }), config)
        .then((res) => {
          if (res) {
            resolve(res.data)
          } else {
            resolve(res)
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  if (method == 'QUERYPOST') {
    return new Promise((resolve, reject) => {
      service({
        method: 'POST',
        url: url,
        data: qs.stringify(data, {arrayFormat: 'indices', allowDots: true}),
        params: param
      })
        .then((res) => {
          if (res) {
            resolve(res.data)
          } else {
            resolve(res)
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  // PUT请求约定格式 数组格式a=1&a=2
  if (method == 'ARRPOST') {
    return new Promise((resolve, reject) => {
      service.post(url, qs.stringify(data, { arrayFormat: 'repeat' }))
        .then((res) => {
          if (res) {
            resolve(res.data)
          } else {
            resolve(res)
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  // POST请求约定格式 文件application/octet-stream
  if (method == 'FILEPOST') {
    return new Promise((resolve, reject) => {
      service({
        method: 'POST',
        url: url,
        data: data
      })
        .then((res) => {
          if (res) {
            resolve(res.data)
          } else {
            resolve(res)
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  // POST请求约定格式 文件application/octet-stream,且可作文件上传进度条功能
  if (method == 'PROFILEPOST') {
    return new Promise((resolve, reject) => {
      // console.log(config,'config')
      service({
        method: 'POST',
        url: url,
        data: data,
        onUploadProgress: config.listenProgress ? config.onUploadProgress : null
      })
        .then((res) => {
          if (res) {
            resolve(res.data)
          } else {
            resolve(res)
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  // PUT请求约定格式 数组格式a[0]=1&a[1]=2
  if (method == 'PUT') {
    return new Promise((resolve, reject) => {
      service.put(url, qs.stringify(data, { arrayFormat: 'indices', allowDots: true }), config)
        .then((res) => {
          if (res) {
            resolve(res.data)
          } else {
            resolve(res)
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  //  PUT请求格式，对象格式data.id=1
  if (method == 'OBJPUT') {
    return new Promise((resolve, reject) => {
      service.put(url, qs.stringify(data, { arrayFormat: 'indices', allowDots: true }))
        .then((res) => {
          if (res) {
            resolve(res.data)
          } else {
            resolve(res)
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  // PUT请求约定格式 数组格式a=1&a=2
  if (method == 'ARRPUT') {
    return new Promise((resolve, reject) => {
      service.put(url, qs.stringify(data, { arrayFormat: 'repeat' }))
        .then((res) => {
          if (res) {
            resolve(res.data)
          } else {
            resolve(res)
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  // DELETE约定格式 数组格式a[0]=1&a[1]=2
  if (method == 'DELETE') {
    return new Promise((resolve, reject) => {
      service.delete(url, {
        params: data,
        paramsSerializer: params => {
          return qs.stringify(params)
        },
        config
      })
        .then((res) => {
          if (res) {
            resolve(res.data)
          } else {
            resolve(res)
          }
        }).catch((err) => {
          reject(err)
        })
    })
  }

  // DELETE约定格式 数组格式a=1&a=2
  if (method == 'ARRDELETE') {
    return new Promise((resolve, reject) => {
      service.delete(url, {
        params: data,
        paramsSerializer: params => {
          return qs.stringify(params, {
            arrayFormat: 'repeat'
          })
        }
      })
        .then((res) => {
          if (res) {
            resolve(res.data)
          } else {
            resolve(res)
          }
        }).catch((err) => {
          reject(err)
        })
    })
  }
}
